"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _starUnstarred = _interopRequireDefault(require("@atlaskit/icon/core/star-unstarred"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StarLargeIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m15.673 14.042 3.673-3.58-5.076-.738L12 5.125l-2.27 4.6-5.076.737 3.673 3.58-.867 5.055L12 16.711l4.54 2.386zM12 19.04l-4.505 2.37a1.546 1.546 0 0 1-2.244-1.63l.86-5.017-3.644-3.553a1.546 1.546 0 0 1 .857-2.637l5.037-.732 2.252-4.564a1.546 1.546 0 0 1 2.774 0l2.252 4.564 5.037.732a1.546 1.546 0 0 1 .857 2.637l-3.645 3.553.86 5.016a1.546 1.546 0 0 1-2.243 1.63z"/></svg>`
}, props, {
  newIcon: _starUnstarred.default
}));
StarLargeIcon.displayName = 'StarLargeIcon';
var _default = exports.default = StarLargeIcon;